module.exports = __webpack_public_path__ + "img/pubag-logo.b2a05ada.png";